import axios from "axios";

// 运行时配置优先，其次构建期环境变量，最后回退相对路径。
// - 运行时：public/config.js 注入 window.__APP_CONFIG__.API_BASE_URL
// - 回退：相对路径（需由同域反向代理转发 /api）

type AppConfig = { API_BASE_URL?: string };
const runtimeBase = (window as any).__APP_CONFIG__?.API_BASE_URL as string | undefined;
const baseURL = (runtimeBase ?? "").trim();

if (process.env.NODE_ENV === "development") {
  // eslint-disable-next-line no-console
  console.info("[axios] baseURL=", baseURL || "<relative / same-origin>");
}

const api = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
